// extracted by mini-css-extract-plugin
module.exports = {"sponsors":"Sponsors_sponsors__3c0Gs","title":"Sponsors_title__1Kb4G","container":"Sponsors_container__35pRy"};